module.exports = __webpack_public_path__ + "img/r-michelle-tsang-500721-unsplash-min-200x132.c51a53ed.jpg";